module.exports = __webpack_public_path__ + "img/zhan3.add83353.png";